// services/f-core/src/components/ShellV2/navAdapter.js

// Icons follow the design prototype's NAV (f-core-revamped/data.jsx) and take
// precedence over whatever navRoutes.js declares (legacy entries mix string
// icons with JSX nodes the new Sidebar cannot render).
const ICON_BY_KEY = {
  community: "apartment",
  members: "groups",
  infrastructure: "tune",
  omie: "public",
  loads_collapse: "electric_meter",
  dso: "lan",
  energy_management: "bolt",
  market: "storefront",
  settlement: "euro",
  simulation: "science",
  run_operations: "play_circle",
  dashboard: "space_dashboard",
  structure: "account_tree",
  default: "circle",
};

const stringIcon = (icon, key, name) => {
  if (ICON_BY_KEY[key]) return ICON_BY_KEY[key];
  // Dashboard's nav key is the community id; match by name instead.
  if (name === "Dashboard") return ICON_BY_KEY.dashboard;
  if (typeof icon === "string") return icon;
  return ICON_BY_KEY.default;
};

export default function adaptNavRoutes(legacy) {
  const out = [];
  legacy.forEach((entry) => {
    if (entry.isAllowed === false) return;
    if (entry.type === "title") {
      out.push({ type: "section", name: entry.title, key: entry.key });
      return;
    }
    if (entry.type !== "collapse") return;

    const icon = stringIcon(entry.icon, entry.key, entry.name);
    if (entry.noCollapse || !entry.collapse) {
      // single item with a route
      // Dashboard's key is the communityId itself; expose a stable nav key.
      out.push({
        type: "item",
        key: entry.key,
        name: entry.name || "Dashboard",
        icon,
        route: entry.route,
      });
      return;
    }

    const children = (entry.collapse || [])
      .filter((c) => c.isAllowed !== false)
      .map((c) => ({ key: c.key, name: c.name, route: c.route }));
    if (children.length === 0) return;
    out.push({
      type: "group",
      key: entry.key,
      name: entry.name,
      icon,
      children,
    });
  });
  return out;
}
